/**
 * Created by trpgw37 on 6/18/19.
 */

import { createSelector } from 'reselect';
import { sortByMMDDYYY } from 'services/Sorts';

const getNasuApplicationsCount = (state) => state.nasuApplications;
export const getInprogressCount = createSelector(
  getNasuApplicationsCount,
  (nasuApplications) => {
    return nasuApplications && nasuApplications.count
      ? nasuApplications.count
      : 0;
  }
);

//new selector for inprogressV2
export const getNasuApplications = (state) => state.nasuApplications;
export const getInProgress = createSelector(
  getNasuApplications,
  (nasuApplications) => {
    //sort oldest to newest date
    //uses 'MM/DD/YYYY' date sort
    return nasuApplications && nasuApplications.length > 0
      ? nasuApplications.sort((a, b) => {
          return sortByMMDDYYY(a.createDate, b.createDate);
        })
      : [];
  }
);